import { useInView } from "framer-motion";
import { useEffect, useRef, useState } from "react";
import { motion } from "framer-motion";
import "./GroupCompanies.css"
import percinlilogo from "../../src/assets/perçinli_logo.jpeg"

const GroupCompanies = () => {
    const ref = useRef();
    const isInView = useInView(ref, { once: true, margin: "-100px" });
    const [isMobile, setMobile] = useState(false);

    useEffect(() => {
        const handleResize = () => setMobile(window.innerWidth <= 768);
        window.addEventListener('resize', handleResize);
        handleResize();
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <motion.div 
            ref={ref}
            initial={{ opacity: 0, y: 30 }}
            animate={isInView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.8, ease: "easeOut" }}
            className="group-companies-section"
            style={{ padding: isMobile ? "4rem 1rem" : "6rem 0", textAlign: 'center', backgroundColor: '#ffffff' }}
        >
            <div className="container">
                <span style={{ 
                    color: "#1a7373", 
                    fontWeight: "700", 
                    letterSpacing: "2px", 
                    textTransform: "uppercase",
                    fontSize: "0.9rem",
                    display: "block",
                    marginBottom: "1rem"
                }}>
                    İştiraklerimiz
                </span>
                
                <h2 style={{ 
                    fontSize: isMobile ? "1.8rem" : "2.5rem", 
                    fontWeight: "800", 
                    marginBottom: "3rem",
                    color: "#333" 
                }}>
                    Grup Şirketleri
                </h2>

                <motion.div 
                    whileHover={{ scale: 1.02 }}
                    className="company-card"
                    style={{
                        maxWidth: "600px",
                        margin: "0 auto",
                        background: "white",
                        padding: "3rem",
                        borderRadius: "20px",
                        boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
                        border: "1px solid #eee",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        gap: "1rem"
                    }}
                >
                    {/* Şirket Logosu veya İkonu */}
                    <div style={{
                        width: "60px",
                        height: "60px",
                        borderRadius: "12px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        marginBottom: "1rem"
                    }}>
                        <img src={percinlilogo} alt="Perçinli Logo" width={250}/>
                    </div>

                    <p style={{ color: "#777", fontSize: "0.95rem" }}>Alt Yapı ve Üst Yapı Projeleri</p>
                </motion.div>
            </div>
        </motion.div>
    );
}

export default GroupCompanies;